import { setLocaleNumFmtForced } from "./";

export const setLocaleNumFmt = (locale: string, cell: any): any => {
  if (typeof cell.value === "number") {
    cell = setLocaleNumFmtForced(locale, cell);
  }
  return cell;
};
